import React from 'react';
import { History } from 'history';
import { Input, InputDate, InputMoney, InputMultiline, InputSwitch, InputPicklist } from '../../components';
import BaseCopy from '../base/base-copy.component'; 
import Model from './transactionpayment-model';  //editable..
import PaymenttypePicklist from '../paymenttype/paymenttype-picklist.component';

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class TransactionpaymentCopy extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
        this.onChange = this.onChange.bind(this);
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }
    
    private onLoadPaymenttype = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'paymenttype': data?.id, 'paymenttypeCaption': data?.name || ''}  });
    }


    private onError = (data: any) => {
        this.setState({errors: data});
    }
    
    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
        this.setState(nextState);
    }

    render() {
        return (
            //editable..
            <BaseCopy history={this.props.history} 
                model={Model} datarow={this.state.datarow} onLoad={this.onLoad} onError={this.onError}>              
                
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} error={this.state.errors?.status} onChange={this.onChange}/>
                <Input name='name' label='Name' value={this.state.datarow.name} error={this.state.errors?.name} onChange={this.onChange} />
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} error={this.state.errors?.description} onChange={this.onChange} />
                <InputDate name='paymentdate' label='Date' value={this.state.datarow.paymentdate} error={this.state.errors?.paymentdate} onChange={this.onChange} />
                <InputPicklist name='paymenttype' label='Type' value={this.state.datarow.paymenttype} caption={this.state.datarow.paymenttypeCaption} error={this.state.errors?.paymenttype} onChange={this.onChange} >
                    <PaymenttypePicklist currentId={this.state.datarow.paymenttype} onLoad={this.onLoadPaymenttype}/>
                </InputPicklist>                 
                <InputMoney name='value' label='Payment' value={this.state.datarow.value} error={this.state.errors?.value} onChange={this.onChange} />
               
            </BaseCopy>
        );
    }
}